import { Controller } from "@hotwired/stimulus"

// Auto-dismiss admin flash banners.
//
// Used by Admin::FlashComponent. Schedules a fade-out after `delayValue` ms
// (default 5000), then removes the element from the DOM after the CSS
// transition (200ms) so layout collapses cleanly.
//
// Click on the dismiss button fires the `dismiss` action and bypasses the
// timer.
export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.timeoutId = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    if (this.timeoutId) clearTimeout(this.timeoutId)
  }

  dismiss() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
    this.element.classList.add("opacity-0")
    setTimeout(() => {
      if (this.element && this.element.parentNode) {
        this.element.parentNode.removeChild(this.element)
      }
    }, 200)
  }
}
